import React, { Component } from 'react';
import { Link, Navigate, useNavigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import './../custom.css';

export class ClassEdit extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          name: '',
          level: 1,
          group_permission_id: 1,
          s: '',
          limit: 100,
          user_type: "classroom",
          thumbnail: null,
          full_thumbnail: null,
          all_permission: [],

          folder_id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_student: [],

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          class_id: null,
          fields: {
            name: "",
            // description: ""
          },
          errors: {},
        }
        this.inputRefs = {
          name: React.createRef(),
          // description: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id");
        this.getOneClass();
        this.getAllUsers();
        this.getAllPermission();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.class_id = id;
        // this.setState({category_id : id})
        this.setState({})
        // return 
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      getOneUser = async (id) => {
        try {
          let query = `user_id=${id}`
          let results = await API.getOneUser(query);
    
          let data = results.data.user;
          this.state.added_student.push(data)
          this.setState({})
          // this.setState({ user : data });
    
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneClass = async () => {
        try {
          let query = `class_id=${this.state.class_id}`
          let results = await API.getOneClsss(query);
    
          let data = results.data;

          let get_all_student = data.user_id;

          get_all_student.map(id => {
            this.getOneUser(id);
          })
          // this.setState({ 
          //   data : data, 
          //   name: data.name,
          //   level: data.level,
          //   group_permission_id: data.group_permission_id,
          //   thumbnail: data.thumbnail_url
          // });
          this.state.data = data;
          this.state.name = data.name;
          this.state.level = data.level;
          this.state.group_permission_id = data.group_permission_id;
          this.state.thumbnail = data.thumbnail_url;
          this.state.fields.name = data.name;
          this.setState({})

    
        } catch (error) {
          console.log(error)
        }
      }

      getAllUsers = async () => {
        try {
          let query = `user_type=${this.state.user_type}&page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllUsers(query);
    
          let data = results.data.result;
          
          this.setState({ quizs : data.users, total: data.total, limit: data.limit  });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        this.state.s = event.target.value;
        this.state.page = 1;
        this.setState({})
        
        this.getAllUsers();
        
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        if (!file) return;
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          if (!fields[field].trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            if (!firstEmptyField) {
              firstEmptyField = field; // Record the first empty field
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }

      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ data: {
      //     ...this.state.data,
      //     [name]: value
      //   }})
      // }
      
      onRemoveQuestion(data){
        this.state.added_student.splice(this.state.added_student.indexOf(data), 1);
        this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      onAddQuestion(data) {
        data.new = true;
        this.state.added_student.unshift(data);
        // this.state.added_student.push(data);
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }

      getAllPermission = async () => {
        try {
          let query = `limit=${this.state.limit}`
          let results = await API.getAllPermission(query);
          let data = results.data;
          
          this.setState({ all_permission : data.permission });
    
        } catch (error) {
          console.log(error)
        }
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        if (!this.validateFields()) return
        // let quis_id = [];
        let student_id = this.state.added_student.map(stu => {
          return stu.id
        });

         let data = {
          id: this.state.class_id,
          name: this.state.name,
          level: this.state.level,
          group_permission_id: this.state.group_permission_id,
          // description: this.state.description,
          // code: this.state.code,
          // thumbnail: this.state.thumbnail,
          user_id: JSON.stringify(student_id)
         }
        // this.state.data.quiz_id = JSON.stringify(quiz_id)
        try {
          let results = await API.postOneClass(data);
          if (results.result === 1){
            
            this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      goBack = () => {
        this.props.navigate(-1); // Navigate to the previous page
      };

      linkToNewPage= async (id) => {
        let element = document.getElementById(`viewuser${id}`);
        element.click();
      }

  render() {
    const { fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to={`/classview?id=${this.state.class_id}`} replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title">Class</h4>

                <div className="card-body row">

                    <div className="col-md-6">
                      <div className="form-group">
                          <label className="require" for="input-required">Name</label>
                          <input type="text" className="form-control" id="input-required" value={this.state.name} name='name' 
                            ref={this.inputRefs.name}
                            style={{
                              border: errors.name ? "1px solid red" : "", // Apply red border on error
                            }}
                            onChange={(event) => {
                              this.state.name = event.target.value;
                              this.setState({})
                              this.handelInput(event)
                            }} />
                             {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                      </div>
                    </div>


                    {/* <div className="col-md-6">
                      <div className="form-group">  
                            <label for="inputState" className="form-label">Level</label>
                            <select id="inputState" className="form-control" value={this.state.level} onChange={(event) => {
                                this.state.level = event.target.value;
                                this.setState({})
                              }}>
                            <option value={1}>Level 1</option>
                            <option value={2}>Level 2</option>
                            <option value={3}>Level 3</option>
                            </select>
                        </div>
                    </div> */}
                    <div className="col-md-6">
                      <div className="form-group">  
                            <label for="inputState" className="form-label">Permission</label>
                            <select id="inputState" className="form-control" value={this.state.group_permission_id} onChange={(event) => {
                                this.state.group_permission_id = event.target.value;
                                // this.state.fourimageVisible = !this.state.fourimageVisible;
                                this.setState({})
                              }}>
                            {
                              this.state.all_permission.map((per, index) => {
                                return <option value={per.id}>{per.name}</option>
                              })
                            }    
                            {/* <option value={1}>Level 1</option> */}
                            {/* <option value={2}>Level 2</option>
                            <option value={3}>Level 3</option> */}
                            </select>
                        </div>
                    </div>
                    
                </div>



                {/* add questions */}
                
                

                <h4 className="card-title"><strong><h5>Student in this class : <b className="text-success fw-500 w-80px">{this.state.added_student.length}</b>&nbsp;<i class="fa fa-users"> </i></h5></strong></h4>
                <div className="card-body row">

                    <div className="col-md-12">



                    <div className="card-body">

                  <div className="flexbox mb-20">
                      <div className="lookup">
                        <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                      </div>

                      <div className="btn-toolbar">
                        <div className="btn-group btn-group-sm">
                        {/* <Select
                          required
                          styles={{
                            menu: provided => ({ ...provided, zIndex: 9999 }),
                            control: (base, state) => ({
                              ...base,
                              '&:hover': { borderColor: '#4ed2c5' },
                              // '&:focus': {
                              //   borderColor: '1px solid #4ed2c5',
                              //   // boxShadow: '0px 0px 6px #4ed2c5',
                              // },
                              // border: '1px solid #4ed2c5',
                              borderColor: state.isFocused ? '#4ed2c5' : '#ebebeb',
                              boxShadow: 'none',
                              width:'200px',
                          }),
                          }}
                          defaultValue={{
                            value: 0,
                            label: 'All',
                            id: 0
                          }}
                          isMulti={this.state.isMulti}

                          name="options"
                          options={this.state.all_categories}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          
                          onChange={value => {
                            this.getOneCategory(value.id);
                            // this.setState({selected_tag: value})
                            
                          }}
                        /> */}

                          {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                          {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                          {/* <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link> */}
                          {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                        </div>

                        {/* <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                          <button className="btn dropdown-toggle" data-toggle="dropdown">Type</button>
                          <div className="dropdown-menu dropdown-menu-right">
                            
                            <a className="dropdown-item" href="/">All</a>
                            <a className="dropdown-item" href="/">Reading</a>
                            <a className="dropdown-item" href="/">Listioning</a>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    <div>
                   </div>
                </div>
                    <div >
                      <table className="table table-hover table-has-action">  
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Thumbnail</th>
                            <th>Name</th>
                            <th>Gender</th>
                            {/* <th>Code</th> */}
                            <th>Phone Number</th>
                            {/* <th>Release Date</th> */}
                            <th className="text-center w-250px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          this.state.quizs && this.state.quizs.map((quiz, index)=> {
                            // quiz style

                            let add_id = this.state.added_student.map(q => q.id);

                            let style = {};

                            let added = false;

                            if (add_id.includes(quiz.id)) {
                              style = {background: '#d9d9d9'};
                              added = true;
                            }

                            return <tr style={style}>
                              <th onClick={() => this.linkToNewPage(quiz.id)} scope="row">{( (this.state.page - 1) * 10) + (index+ 1)} </th>
                              <td onClick={() => this.linkToNewPage(quiz.id)}>
                                <div class="media">
                                  <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                                  <div class="media-body">
                                  </div>
                                </div>
                              </td>
                              <td onClick={() => this.linkToNewPage(quiz.id)}>{quiz.last_name+ ' ' + quiz.first_name}</td>
                              <td onClick={() => this.linkToNewPage(quiz.id)}> {quiz.gender_id === 1? "Male" : "Female"}</td>
                              <td onClick={() => this.linkToNewPage(quiz.id)} className="text-center w-200px">{quiz.email}</td>
                              <td className="text-center table-actions">
                              <Link title="View" class="btn btn-square btn-round btn-primary" id={`viewuser${quiz.id}`} to={`/userview?id=${quiz.id}`}><i className="fa fa-eye"></i></Link>
                                <span>&nbsp;</span><Link title="Edit" class="btn btn-square btn-round btn-info" to={`/userview?id=${quiz.id}`}><i className="ti-pencil"></i></Link>
                                <span>&nbsp;</span><Link className="btn btn-square btn-round btn-danger" title="Remove" onClick={() => this.onRemoveQuestion(quiz)}><i className="fa fa-minus"></i></Link>
                                <span>&nbsp;</span><button className="btn btn-square  btn-primary" disabled={added} onClick={() => this.onAddQuestion(quiz)}><i className="fa fa-plus" ></i></button>
                                {/* <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${quiz.id}`}><i className="ti-pencil"></i></Link>
                              
                                <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: quiz})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link> */}
                              </td>
                            </tr>
                            
                          })
                        }
                        </tbody>
                      </table>
                     </div>
                    </div>
                </div>    


                <footer className="card-footer text-right">
                    {/* <Link className="btn btn-secondary" to={`/classview?id=${this.state.class_id}`}>Cancel</Link> */}
                    <button class="btn btn-secondary" onClick={() => this.goBack()} >Cancel</button>
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
            </form>
        </div>
    )
  }
}

const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <ClassEdit navigate={navigate} />;
};

export default MyComponentWithNavigate;